import { IAction } from "../action";
import { actionTypes } from "../actions";
var initialState = null;
export function request(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return initialState;
        case actionTypes.dataModelNamesLoaded:
        case actionTypes.dimensionsLoaded:
            return initialState;
        case actionTypes.reportRequestGenerated:
            return action.payload;
        default:
            return state;
    }
}
